import { render, staticRenderFns } from "./QuotationPriceHistories.vue?vue&type=template&id=5056c31c&"
import script from "./QuotationPriceHistories.vue?vue&type=script&lang=js&"
export * from "./QuotationPriceHistories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports